import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/store.js'
import PageNotFound from "client/components/application/pageNotFound.vue"
import pageUserInfo from "client/components/application/pageUserInfo.vue"
import pageCourseOptions from "client/components/application/pageCourseOptions.vue"

Vue.use(VueRouter)

const routes = [
   {
      name: "user-info",
      path: "/",
      component: pageUserInfo,
      meta: { step: 1, }
   },
   {
      name: "course-options",
      path: "/course-options",
      component: pageCourseOptions,
      meta: { step: 2, }
   },
   {
      name: "results",
      path: "/results",
      component: pageCourseOptions,
      meta: { step: 3, }
   },
   // {
   //    name: "main-content",
   //    path: "/:path", //uses a parameter to determine the componenet used
   //    component: MainContent //Main content - is the global element in the fee calculator that will change with each step of the process
   // },
   /*
    {
        name: "redirected",
        path : '*', //if no path is given - redirect to the main-content route with the path paramater as the store/step module defined default path
        redirect: { name: 'user-info' }
    },
    */
   {
      name: "not-found",
      path: "*", //if no path is given - redirect to the main-content route with the path paramater as the store/step module defined default path
      component: PageNotFound
   }
];


class Router {
   static init(base) {
      const router = new VueRouter({
         mode: "history",
         base,
         linkActiveClass: "active",
         routes
      })

     /*
     * before each route loads check if it is part of the list of possible routes determined by the store
     * and also checks if this route is enabled in the store
     * to do: make this more robust
     */
      router.beforeEach((to, from, next) => {
         if(to.meta.step && store.state.global.steps.find(step => step.id === to.meta.step).enabled){
            store.dispatch('setCurrent', to.meta.step)
            next()
         }else if(to.meta.step){
            next({name:'user-info'})
         }else{
            next()
         }
      })
     return router
   }
}
export default Router
